import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import FormElementErrorMessage from './FormElementErrorMessage'

const FormElementOptionGroup = (
    {
        name,
        children,
        error,
        orientation,
        required,
        label,
        description,
        className,
        inlineDescription,
        strongLabel,
        ...rest
    }
) => {
    return (
        <fieldset
            name={name}
            className={classNames(
                'form-element',
                'form-element--option-group',
                `form-element--option-group--${orientation || 'vertical'}`,
                { 'form-element--required': required },
                { 'form-element--invalid': error },
                { 'form-element--inline-description': inlineDescription },
                { 'form-element--strong-label': strongLabel },
                className,
            )}
        >
            {(label || description) && (
                <div className="label-and-description">
                    {label && <label><span>{label}</span>{required && <sup>*</sup>}</label>}
                    {description && (
                        typeof description === 'string' ? (
                            <p className="form-element__description">{description}</p>
                        ) : (
                            description
                        )
                    )}
                </div>
            )}
            {error && (
                <FormElementErrorMessage message={error} />
            )}
            <div className="form-element--option-group__items">
                {children(rest)}
            </div>
        </fieldset>
    )
}

FormElementOptionGroup.propTypes = {
    name: PropTypes.string,
    orientation: PropTypes.oneOf(['vertical', 'horizontal']).isRequired,
    error: PropTypes.any,
    required: PropTypes.bool,
    label: PropTypes.string,
    description: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    className: PropTypes.string,
    inlineDescription: PropTypes.bool,
    strongLabel: PropTypes.bool,
}

FormElementOptionGroup.defaultProps = {
    orientation: 'vertical',
}

export default FormElementOptionGroup
